<template>
  <div
    class="fixed right-0 inset-y-0 bg-white z-[99] shadow-lg max-w-xs w-full flex flex-col"
  >
    <header class="flex justify-between py-3 px-4 bg-sky-500 text-white">
      <h1 class="text-lg">Select Font</h1>
      <button @click="$emit('close')" class="flex items-center">
        <font-awesome-icon :icon="['far', 'circle-xmark']" class="w-5 h-5" />
      </button>
    </header>

    <section class="font-list px-4 py-2">
      <div
        class="font-item selected w-full hover:text-sky-500 text-left py-2 border-b"
        font="arial"
        family="'Arial', sans-serif"
        style="font-family:'Arial', sans-serif;"
        @mouseover="$emit('fontMouseOver','\'Arial\', sans-serif')"
        @mouseleave="$emit('fontMouseLeave', '\'Arial\', sans-serif')"
        @click="$emit('selectFont', 'arial')"
      >
        Arial
      </div>
      <div
        class="font-item w-full hover:text-sky-500 text-left py-2 border-b"
        font="calibri"
        family="'Calibri', sans-serif"
        style="font-family:'Calibri', sans-serif;"
        @mouseover="$emit('fontMouseOver','\'Calibri\', sans-serif')"
        @mouseleave="$emit('fontMouseLeave', '\'Calibri\', sans-serif')"
        @click="$emit('selectFont', 'calibri')"
      >
        Calibri
      </div>
      <div
        class="font-item w-full hover:text-sky-500 text-left py-2 border-b"
        font="timesnewroman"
        family="'Times New Roman', serif"
        style="font-family:'Times New Roman', serif;"
        @mouseover="$emit('fontMouseOver','\'Times New Roman\', serif')"
        @mouseleave="$emit('fontMouseLeave', '\'Times New Roman\', serif')"
        @click="$emit('selectFont', 'timesnewroman')"
      >
        Times New Roman
      </div>
      <div
        class="font-item w-full hover:text-sky-500 text-left py-2 border-b"
        font="arialnarrow"
        family="'Arial Narrow', sans-serif"
        style="font-family:'Arial Narrow', sans-serif;"
        @mouseover="$emit('fontMouseOver','\'Arial Narrow\', sans-serif')"
        @mouseleave="$emit('fontMouseLeave', '\'Arial Narrow\', sans-serif')"
        @click="$emit('selectFont', 'arialnarrow')"
      >
        Arial Narrow
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
